import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqCategoryService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  all(query?: any) {
    return this.get('/cq-all-categories', query);
  }

  list(query?: any) {
    return this.get('/cq-categories', query);
  }

  create(body: any) {
    return this.post('/cq-categories', body);
  }

  find(id) {
    return this.get('/cq-categories/' + id);
  }

  update(id, body) {
    return this.put('/cq-categories/' + id, body);
  }
  _delete(id) {
    return this.delete('/cq-categories/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqCategory.service.ts